<mat-form-field fxFlex="0 0 100%" [appearance]="appearance" subscriptSizing="dynamic">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-chip-grid #chipGrid>
    @for (pattern of patterns; track pattern; let i = $index) {
      <mat-chip-row [removable]="true" (removed)="removePattern(i)"
        [attr.data-index]="i">
        {{ pattern }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    }

    <input matInput [placeholder]="placeholder || ('COMMON.CHIP_MULTISELECT.PLACEHOLDER' | translate)"
      [disabled]="!multiple && patterns?.length > 0"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="addPattern($event)" />
    </mat-chip-grid>
    @if (!multiple) {
      <mat-hint>{{ 'COMMON.CHIP_MULTISELECT.HINT.SINGLE_VALUE' | translate }}</mat-hint>
    }
  </mat-form-field>
